module.exports = __webpack_public_path__ + "static/media/header-apps2.ef425e27.png";